import { useTranslation } from 'react-i18next';
import {
  ModalActionButton,
  ModalCancelButton,
  ModalContent,
  ModalContentActions,
  ModalContentBody,
  ModalContentFooter,
  ModalContentHeader,
  ModalOverlay,
  ModalPortal,
  ModalRoot,
} from '@socialchorus/shared-ui-components';
import { Icon } from '@socialchorus/shared-ui-components';
import './expired-link-dialog.scss';

type ExpiredLinkDialogProps = {
  close: () => void;
};

export const ID = 'Overlay.EXPIRED_LINK_DIALOG';

export default function ExpiredLinkDialog({ close }: ExpiredLinkDialogProps) {
  const { t } = useTranslation();

  const handleReload = () => {
    window.location.reload();
  };

  const titleElements = (
    <>
      <Icon className="text-red-full-value expired-link-dialog__title__icon">
        warning
      </Icon>
      <span>{t('dialogs.expired_link.title')}</span>
    </>
  );

  return (
    <ModalRoot defaultOpen={true} onOpenChange={close}>
      <ModalPortal>
        <ModalOverlay />
        <ModalContent size="small">
          <ModalContentHeader title={titleElements} />
          <ModalContentBody>{t('dialogs.expired_link.body')}</ModalContentBody>
          <ModalContentFooter>
            <ModalContentActions>
              <ModalCancelButton label={t('common.cancel')} />
              <ModalActionButton
                leftIcon={<Icon>refresh</Icon>}
                label={t('dialogs.expired_link.refresh_page')}
                onClick={handleReload}
              />
            </ModalContentActions>
          </ModalContentFooter>
        </ModalContent>
      </ModalPortal>
    </ModalRoot>
  );
}
